import { render } from "./BonusesPanel.vue?vue&type=template&id=0cc6690b&scoped=true&ts=true"
import script from "./BonusesPanel.vue?vue&type=script&lang=ts"
export * from "./BonusesPanel.vue?vue&type=script&lang=ts"

import "./BonusesPanel.vue?vue&type=style&index=0&id=0cc6690b&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cc6690b"]])

export default __exports__